export const GET_PAYMENTS_PENDING = 'GET_PAYMENTS_PENDING';
export const GET_PAYMENTS_COMPLETE = 'GET_PAYMENTS_COMPLETE';
export const GET_PAYMENTS_BY_PARTNER = 'GET_PAYMENTS_BY_PARTNER';
export const GET_ORDERS = 'GET_ORDERS';
